function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  id: "gradient-start-color",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  id: "gradient-stop-color",
  offset: "100%",
  stopColor: "#FFF"
})), /*#__PURE__*/React.createElement("path", {
  id: "b",
  d: "M91 0h34a4 4 0 0 1 4 4v108.144c0 11.519-9.337 20.856-20.856 20.856h-.288C96.337 133 87 123.663 87 112.144V4a4 4 0 0 1 4-4z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  className: "ledger-stroke",
  stroke: "#1D2027",
  strokeWidth: 2,
  d: "M127.856 31.44a1 1 0 0 1-1 1H100.63a5 5 0 0 1-5-5v-8.486a5 5 0 0 1 5-5h26.225a1 1 0 0 1 1 1v16.485z"
}), /*#__PURE__*/React.createElement("path", {
  className: "ledger-stroke",
  stroke: "#142533",
  strokeWidth: 2,
  d: "M95.247 26.231H84.318v-6.435h10.93v6.435z"
}), /*#__PURE__*/React.createElement("path", {
  className: "ledger-stroke",
  stroke: "#1D2027",
  strokeWidth: 2,
  d: "M127.923 28.726V17.471l6.977.083a1 1 0 0 1 .988 1V27.82a1 1 0 0 1-1.012.988l-6.953-.083z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  d: "M6.836 53.925h1.616v82.65H6.836v-82.65zm5.657 0h1.616v82.65h-1.616v-82.65z",
  transform: "matrix(0 -1 -1 0 137.5 33.44)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(-90 128.59 1.975)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "ledger-fill",
  width: 4.492,
  height: 17.12,
  x: 125.336,
  y: 15.505,
  fill: "#142533",
  rx: 2
}), /*#__PURE__*/React.createElement("rect", {
  className: "ledger-fill",
  width: 4.492,
  height: 17.12,
  x: 125.336,
  y: 70.094,
  fill: "#142533",
  rx: 2
}), /*#__PURE__*/React.createElement("use", {
  className: "ledger-fill-inner-bg",
  fill: "#FFF",
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("path", {
  className: "ledger-stroke",
  fill: "#6490F1",
  fillOpacity: 0.15,
  stroke: "#142533",
  strokeLinejoin: "square",
  strokeWidth: 2,
  d: "M91 1a3 3 0 0 0-3 3v108.144C88 123.11 96.89 132 107.856 132h.288C119.11 132 128 123.11 128 112.144V4a3 3 0 0 0-3-3H91z"
}), /*#__PURE__*/React.createElement("rect", {
  className: "ledger-fill-outer-bg",
  width: 21,
  height: 62,
  x: 97.5,
  y: 21.5,
  fill: "#FFF",
  stroke: "#6490F1",
  rx: 1.6
}), /*#__PURE__*/React.createElement("path", {
  fill: "#6490F1",
  d: "M105.5 35h5a.5.5 0 0 1 .5.5v34a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-34a.5.5 0 0 1 .5-.5zm1.238 3.042l.774.512v.013l-.774.505.341.466.722-.577h.013l.243.899.551-.177-.328-.88.932.053v-.597l-.932.046.328-.873-.551-.17-.243.892h-.013l-.722-.584-.34.472zm0 3.908l.774.512v.013l-.774.505.341.466.722-.578h.013l.243.9.551-.178-.328-.88.932.053v-.597l-.932.046.328-.872-.551-.17-.243.891h-.013l-.722-.584-.34.473zm0 3.907l.774.512v.013l-.774.505.341.466.722-.577h.013l.243.899.551-.178-.328-.879.932.053v-.597l-.932.046.328-.873-.551-.17-.243.892h-.013l-.722-.584-.34.472zm0 3.908l.774.511v.014l-.774.505.341.466.722-.578h.013l.243.899.551-.177-.328-.88.932.053v-.597l-.932.046.328-.872-.551-.171-.243.892h-.013l-.722-.584-.34.473zm0 3.907l.774.512v.013l-.774.505.341.466.722-.577h.013l.243.898.551-.177-.328-.879.932.053v-.597l-.932.046.328-.873-.551-.17-.243.892h-.013l-.722-.584-.34.472zm0 3.908l.774.511v.013l-.774.506.341.465.722-.577h.013l.243.899.551-.177-.328-.88.932.053v-.597l-.932.046.328-.873-.551-.17-.243.892h-.013l-.722-.584-.34.473zm0 3.907l.774.512v.013l-.774.505.341.466.722-.578h.013l.243.9.551-.178-.328-.879.932.052v-.597l-.932.046.328-.872-.551-.17-.243.891h-.013l-.722-.583-.34.472zm0 3.907l.774.512v.013l-.774.505.341.466.722-.577h.013l.243.899.551-.177-.328-.88.932.053v-.597l-.932.046.328-.873-.551-.17-.243.892h-.013l-.722-.584-.34.472z"
}), /*#__PURE__*/React.createElement("path", {
  className: "ledger-stroke ledger-fill-outer-bg",
  fill: "#FFF",
  stroke: "#142533",
  strokeWidth: 2,
  d: "M123.166 125.105c7.049-8.4 5.953-20.925-2.447-27.974l-90.824-76.21a3 3 0 0 0-4.227.37L4 47.115a3 3 0 0 0 .37 4.227l90.824 76.21c8.4 7.049 20.924 5.953 27.973-2.447z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 108.016,
  cy: 111.123,
  stroke: "#6490F1",
  rx: 10.57,
  ry: 10.644
})));

function SvgLedgerNano(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ledger-svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 110,
    height: 55,
    viewBox: "0 0 260 129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedgerNano);
export default __webpack_public_path__ + "static/media/ledger-nano.6ece58da.svg";
export { ForwardRef as ReactComponent };